const checkStretchHeight = ({ framePosition, imageDimensions }) => {
  const land_frame = framePosition.width > framePosition.height;
  const land_img = imageDimensions.width > imageDimensions.height;
  const ratio_frame = framePosition.width / framePosition.height;
  const ratio_img = imageDimensions.width / imageDimensions.height;
  const tiny_ratio = ratio_img <= ratio_frame;
  if (!tiny_ratio) {
    if (land_frame && land_img) {
      return true;
    } else if (!land_frame && land_frame) {
      return true;
    }
    if (!(land_frame && land_img)) {
      return true;
    } else if (!(!land_frame && land_frame)) {
      return true;
    }
  }
  return false;
};
const resizeRatioImage = ({ framePosition, imageZoom, imageDimensions }) => {
  const is_stretch_height = checkStretchHeight({
    framePosition,
    imageDimensions,
  });
  if (is_stretch_height) {
    const scaleHeight = (framePosition.height * (imageZoom || 100)) / 100;
    const height = scaleHeight;
    const width = Math.round(
      (scaleHeight * imageDimensions.width) / imageDimensions.height
    );

    return {
      width,
      height,
    };
  } else {
    const scaleWidth = (framePosition.width * (imageZoom || 100)) / 100;
    const width = scaleWidth;
    const height = Math.round(
      (scaleWidth * imageDimensions.height) / imageDimensions.width
    );
    return {
      width,
      height,
    };
  }
};
const cropOptions = (device, options = {}) => {
  const {
    imageRaw,
    cropPosX,
    cropPosY,
    cropWidth,
    cropHeight,
    resizeWidth,
    maxWidthDesktop = 1200,
    maxWidthTablet = 768,
    maxWidthMobile = 576,
    quality,
  } = options;
  if(!imageRaw) return '';
  let cropUrl =
    imageRaw.replace("{{size}}", "crop") +
    `&x=${cropPosX || 0}&y=${cropPosY || 0}&w=${cropWidth}&h=${cropHeight}`;

  if(quality) {
    cropUrl  = cropUrl + '&q=' + quality
  } 

  switch (device) {
    case "desktop":
      if (resizeWidth > maxWidthDesktop)
        return {
          url: cropUrl,
          width: maxWidthDesktop,
          height: maxWidthDesktop,
        };
      return {
        url: cropUrl,
        width: maxWidthDesktop,
        height: maxWidthDesktop,
      };
    case "tablet":
      if (resizeWidth > maxWidthTablet)
        return {
          url: cropUrl,
          width: maxWidthTablet,
          height: maxWidthTablet,
        };
      return {
        url: cropUrl,
        width: maxWidthTablet,
        height: maxWidthTablet,
      };
    case "mobile":
      if (resizeWidth > maxWidthMobile)
        return {
          url: cropUrl,
          width: maxWidthMobile,
          height: maxWidthMobile,
        };
      return {
        url: cropUrl,
        width: maxWidthMobile,
        height: maxWidthMobile,
      };
    case "lazy":
      return {
        url: imageRaw.replace("{{size}}", `r_10x10`),
        width: 10,
        height: 10,
      };
    default:
      return { url: cropUrl + "" };
  }
};
const resizeOptions = (device, options = {}) => {
  let {
    imageRaw,
    resizeWidth,
    resizeHeight,
    maxWidthDesktop = 1200,
    maxWidthTablet = 768,
    maxWidthMobile = 576,
  } = options;
  // if (!(resizeWidth && resizeHeight)) {
  switch (device) {
    case "desktop":
      resizeWidth = resizeWidth || maxWidthDesktop;
      resizeHeight = resizeHeight || maxWidthDesktop;
      break;
    case "tablet":
      resizeWidth = resizeWidth || maxWidthTablet;
      resizeHeight = resizeHeight || maxWidthTablet;
      break;
    case "mobile":
      resizeWidth = resizeWidth || maxWidthMobile;
      resizeHeight = resizeHeight || maxWidthMobile;
      break;
    default:
      break;
  }
  // }
  switch (device) {
    case "desktop":
      if (resizeWidth > maxWidthDesktop)
        return {
          url: imageRaw.replace(
            "{{size}}",
            `r_${maxWidthDesktop}x${maxWidthDesktop}`
          ),
          width: resizeWidth,
          height: resizeHeight,
        };
      return {
        url: imageRaw.replace("{{size}}", `r_${resizeWidth}x${resizeHeight}`),
        width: resizeWidth,
        height: resizeHeight,
      };
    case "tablet":
      if (resizeWidth > maxWidthTablet)
        return {
          url: imageRaw.replace(
            "{{size}}",
            `r_${maxWidthTablet}x${maxWidthTablet}`
          ),
          width: maxWidthTablet,
          height: maxWidthTablet,
        };
      return {
        url: imageRaw.replace("{{size}}", `r_${resizeWidth}x${resizeHeight}`),
        width: maxWidthTablet,
        height: maxWidthTablet,
      };
    case "mobile":
      if (resizeWidth > maxWidthMobile)
        return {
          url: imageRaw.replace(
            "{{size}}",
            `r_${maxWidthMobile}x${maxWidthMobile}`
          ),
          width: maxWidthMobile,
          height: maxWidthMobile,
        };
      return {
        url: imageRaw.replace("{{size}}", `r_${resizeWidth}x${resizeHeight}`),
        width: maxWidthMobile,
        height: maxWidthMobile,
      };
    case "lazy":
      return {
        url: imageRaw.replace("{{size}}", `r_100x100`),
        width: 100,
        height: 100,
      };
    default:
      return { url: imageRaw.replace("{{size}}", "0") };
  }
};
const imageOptions = (device = "desktop", options = {}) => {
  const { mode = "crop" } = options;
  switch (mode) {
    case "crop":
      return cropOptions(device, options);
    case "resize":
      return resizeOptions(device, options);
    default:
      return "";
  }
};

const checkDimensionFile = async (file) => {
  return new Promise((resolve) => {
    getMeta(
      file.replace("{{size}}", 0),
      function (width, height) {
        resolve({
          width: width,
          height: height,
        })
      }
    )
  })
}
const getMeta = (url, callback) => {
  var img = new Image();
  img.src = url;
  img.onload = function () {
    callback(this.width, this.height);
  };
}

const _IMG_VERSION_ = process.env.VUE_APP_IMG_VERSION;
const _RESOLUTIONS_ = {
  "1920w": { w: 1920, h: 1920 },
  "1400w": { w: 1400, h: 1400 },
  "1080w": { w: 1080, h: 1080 },
  "750w": { w: 750, h: 750 },
  "640w": { w: 640, h: 640 },
  "480w": { w: 480, h: 480 },
  "320w": { w: 320, h: 320 },
}
const _RESOLUTIONS_ASC_ = [
  "320w",
  "480w",
  "640w",
  "750w",
  "1080w",
  "1400w",
  "1920w",
]
const _RESOLUTIONS_DESC_ = [
  "1920w",
  "1400w",
  "1080w",
  "750w",
  "640w",
  "480w",
  "320w",
]

// Get some resolutions which support width
const getResolutions = (width) => {
  let resolutions = {};

  for (let i = 0; i < _RESOLUTIONS_ASC_.length; i++) {
    const key = _RESOLUTIONS_ASC_[i];
    resolutions[key] = { ..._RESOLUTIONS_[key] };
    if (width <= _RESOLUTIONS_[key].w) break;
  }

  return resolutions;
}

// Get string url after replace {{size}}, {{version}}
const replaceUrl = (url, size = '0') => {
  return url && url.replace("{{size}}", size).replace(/{{version}}|202012190947|202405081832|202405230214/gi, _IMG_VERSION_) || '';
}

// Get object includes width, height after resize
const resize = (w, h, rw = null, rh = null) => {
  if (rw && !rh) return { 
    w: rw, 
    h: Math.floor(rw * h / w)
  }
  if (!rw && rh) return { 
    w: Math.floor(w / h * rh), 
    h: rh
  }
  return { 
    w: w, 
    h: h 
  }
}

// Generate url by configs
const genUrl = (options = {}) => {
  const { 
    mode = "original",
    imageRaw,
  } = options;
  if(!imageRaw) return '';
  
  let result;
  switch (mode) {
    case "resize": result = genUrlResize(options); break;
    case "resizeMax": result = genUrlResizeMax(options); break;
    case "crop": result = genUrlCrop(options); break;
    default: result = genUrlOriginal(options);
  }

  return result;
};
const genUrlOriginal = (options = {}) => {
  let {
    imageRaw,
  } = options;
  if(!imageRaw) return '';

  let url = replaceUrl(imageRaw, '0');

  return url;
};
const genUrlResize = (options = {}) => {
  let {
    imageRaw,
    resizeWidth = 0,
    resizeHeight = 0,
  } = options;
  if(!imageRaw) return '';

  let url = replaceUrl(imageRaw, `r_${resizeWidth}x${resizeHeight}`);

  return url;
};
const genUrlResizeMax = (options = {}) => {
  let {
    imageRaw,
    resizeWidth = 0,
    resizeHeight = 0,
  } = options;
  if(!imageRaw) return '';

  let url = replaceUrl(imageRaw, `m_${resizeWidth}x${resizeHeight}`);

  return url;
};
const genUrlCrop = (options = {}) => {
  let {
    imageRaw,
    cropPosX = 0,
    cropPosY = 0,
    cropWidth,
    cropHeight,
    resizeWidth,
    resizeHeight,
    quality,
  } = options;
  if(!imageRaw) return '';

  let url = replaceUrl(imageRaw, 'crop');
  url += `&x=${cropPosX}&y=${cropPosY}&w=${cropWidth}&h=${cropHeight}`;
  if (resizeWidth) url += `&rw=${resizeWidth}`;
  if (resizeHeight) url += `&rh=${resizeHeight}`;
  if (quality) url += `&q=${quality}`;

  return url;
};



export { 
  _RESOLUTIONS_,
  _RESOLUTIONS_ASC_,
  _RESOLUTIONS_DESC_,
  getResolutions,
  replaceUrl,
  resize,
  genUrl, 
  genUrlOriginal,
  genUrlResize,
  genUrlResizeMax,
  genUrlCrop,
  checkStretchHeight, 
  resizeRatioImage, 
  imageOptions, 
  checkDimensionFile, 
  getMeta 
};
export default { 
  _RESOLUTIONS_,
  _RESOLUTIONS_ASC_,
  _RESOLUTIONS_DESC_,
  getResolutions,
  replaceUrl,
  resize,
  genUrl, 
  genUrlOriginal,
  genUrlResize,
  genUrlResizeMax,
  genUrlCrop,
  checkStretchHeight, 
  resizeRatioImage, 
  imageOptions, 
  checkDimensionFile, 
  getMeta 
};
